<script>
  import { createEventDispatcher } from 'svelte';
  import Field from './Field.svelte';

  export let label;
  export let type = 'text';
  export let placeholder;
  export let value;
  export let isRequired = false;

  const dispatch = createEventDispatcher();
</script>

<Field {label} {isRequired}>
  <input class="input" {type} {placeholder} {value} on:input={e => dispatch('input', { value: e.target.value })} />
</Field>
